<template>
  <section>
    <div>
      <form class="lm-forms">
        <div class="columns">
          <div class="column is-3 local-lm-filters">
            <b-field
              class="lm-label"
              :label="$t('NewVehicle.labelRegistration')"
              :type="validateRegistration"
              :message="errorRegistration"
            >
              <b-input
                class="local-lm-filters--input lm-xpecial__input-up"
                maxlength="8"
                v-model.trim="$v.registration.$model"
              />
            </b-field>
          </div>
          <div class="column is-9 local-lm-filters">
            <div class="buttons local-lm_space-mTop">
              <b-button
                v-t="'Common.register'"
                type="is-success"
                class="button lr-width-50 lr-btn lr-txt-up"
                @click.prevent="register"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import { required, helpers } from 'vuelidate/lib/validators'
import { mixin } from '@/mixins'

export default {
  name: 'NewVehicle',
  mixins: [
    mixin.notifications
  ],
  data () {
    return {
      registration: ''
    }
  },
  methods: {
    async register () {
      if (this.$v.$invalid) return false

      const user = await this.$store.getters['user/status'].info
      const data = {
        id: user.operators[0],
        registration: this.registration.toUpperCase()
      }

      const newRegistration = await this.$store.dispatch('user/setRegistration', data)
      if (!newRegistration.level) return this.wrong(this.$t(newRegistration.errorText))

      this.registration = ''
      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('registration')
    }
  },
  computed: {
    validateRegistration () {
      return !this.$v.registration.confirm
        ? 'is-danger'
        : null
    },
    errorRegistration () {
      return !this.$v.registration.confirm
        ? this.$t('Errors.validRegistration')
        : null
    }
  },
  validations: {
    registration: {
      required,
      confirm (registration) {
        const regex = /^[A-Za-z0-9]{2}[-][A-Za-z0-9]{2}[-][A-Za-z0-9]{2}/g
        const alpha = helpers.regex('alpha', regex)

        return !helpers.req(registration) || alpha(registration)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/NewVehicle.vue